import { render } from "./TranslationFieldActions.vue?vue&type=template&id=426e9510"
import script from "./TranslationFieldActions.vue?vue&type=script&lang=js"
export * from "./TranslationFieldActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__